import { createFileRoute, Link, Outlet } from '@tanstack/react-router';

const SETTINGS_TABS = [
  { label: 'Sequences', to: '/settings/sequences' },
  { label: 'Integrations', to: '/settings/integrations' },
] as const;

function SettingsLayout() {
  return (
    <div className="flex flex-col">
      <div className="border-b border-border px-6 pt-6">
        <h1 className="text-2xl font-semibold text-foreground">Settings</h1>
        <nav className="mt-4 flex gap-6" aria-label="Settings">
          {SETTINGS_TABS.map((tab) => (
            <Link
              key={tab.to}
              to={tab.to}
              className="-mb-px border-b-2 border-transparent pb-3 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
              activeProps={{ className: 'border-primary text-foreground' }}
            >
              {tab.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="p-6">
        <Outlet />
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_dashboard/settings')({
  component: SettingsLayout,
});
